import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useMemo } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { BindInput } from '../../../../hooks/useInput';

type PhoneNumberInputProps = BindInput & {
  className?: string;
  disabled?: boolean;
  invalidFields?: string[];
  name: string;
  testId?: string;
};

export function PhoneNumberInput({ name, invalidFields, disabled, ...props }: PhoneNumberInputProps) {
  const { getContentByPath } = useContent();

  const error = useMemo(
    (): string | undefined =>
      invalidFields && invalidFields.includes(name) ? getContentByPath('shared.fields.phoneNumber.error') : undefined,
    [getContentByPath, invalidFields, name],
  );

  return (
    <div data-testid='phone-number-input-wrapper'>
      <TextInput
        variant='phone-number'
        id='phoneNumber'
        label='Phone Number'
        value={props.value}
        error={!!error}
        hint={error}
        onPhoneNumberChange={(value: string) => {
          props.onChange({
            target: {
              value,
            },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        onBlur={props.onBlur}
        disabled={disabled}
        testId={props.testId || 'phone-number-input'}
        data-private='true'
        autoComplete='tel-national'
      />
    </div>
  );
}
